/**
* reducers for the portfolio
*
* Created by Tom on 20/06/18
*/

import C from '../constants'

const initState = {
    pLoading: false,
    pFetchSuccess: true,
    pData: [],
    pFundValue: 0
}

export const portfolioState = (state = initState, action) => {

    switch(action.type) {

        // in case of `pLoading` change
        case C.SET_PORTFOLIO_LOADER :
            return {
                ...state,
                pLoading: action.payload
            }

        // in case of `pData` change
        case C.SET_PORTFOLIO_DATA:
            return {
                ...state,
                pData: action.payload
            }

        // in case of `iInvestmentSuccess` change
        case C.SET_PORTFOLIO_FETCH_SUCCESS:
            return {
                ...state,
                pFetchSuccess: action.payload
            }

            // in case of `tClosingBalance` change
        case C.SET_PORTFOLIO_FUND_VALUE:
            return {
                ...state,
                pFundValue: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/portfolioReducers.js